import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { fetchStatus } from '../status';
import { getClients } from '../../api/sdk';

// Then, handle actions in your reducers:
const clientsSlice = createSlice({
  name: 'clients',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    clientsFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    clientsFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    clientsFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
  },
});

export const { clientsFetchStart, clientsFetchSuccess, clientsFetchFail } = clientsSlice.actions;

export const clientsReducer = clientsSlice.reducer;

export const fetchClients = () => (dispatch) => {
  dispatch(clientsFetchStart());
  getClients()
    .then((payload) => {
      dispatch(clientsFetchSuccess(payload.data));
    })
    .catch((error) => {
      dispatch(clientsFetchFail(error));
    });
};
